export default {"src":"/_next/static/media/shadow-theatre.41e280a6.svg","height":64,"width":129,"blurWidth":0,"blurHeight":0};